export default {
  table_ordering: 'Pedido à mesa',
  table: 'Mesa',
  pickup_or_delivery: 'Takeaway ou entrega',
  asap: 'O mais depressa possível',
  served_in: 'Servido em {{time}} min',
  not_taking_orders: 'Sem aceitar pedidos',
  not_your_table: 'Não é a sua mesa? Leia o código da sua.',
  eating_here: {
    title: 'Vai comer aqui?',
    back_to_table: 'Pedido para {{table}}. Levamos-lhe o pedido à mesa.',
    scan_code: 'Leia o código QR na sua mesa para pedir diretamente para ela.',
  },
  notes: {
    table_unavailable: {
      title: 'O código QR desta mesa já não funciona.',
      text: 'Por favor, peça ajuda ao pessoal. Pode continuar a fazer um pedido para levantamento.',
      text_no_pickup: 'Por favor, peça ajuda ao pessoal.',
    },
    table_ordering_off: {
      title: 'O pedido à mesa não está disponível neste momento.',
      text: 'Pode fazer o pedido para levantamento.',
    },
    load_failed: {
      title: 'Não foi possível carregar a tua mesa.',
      text: 'Digitaliza novamente o código QR.',
    },
    closed: {
      title: 'Fechado neste momento.',
      text: 'Pode pedir na sua mesa a partir das {{time}}.',
      text_later: 'Pode pedir na sua mesa quando voltarmos a abrir.',
    },
    paused: {
      title: 'Sem aceitar pedidos neste momento.',
      text: 'Por favor, peça ajuda ao pessoal ou tente novamente dentro de alguns minutos.',
    },
  },
  cart: {
    closed: 'Fechado neste momento. Pode pedir na sua mesa a partir das {{time}}. O seu cesto é guardado até lá.',
    closed_later: 'Fechado neste momento. O seu cesto é guardado até voltarmos a abrir.',
    paused: 'Sem aceitar pedidos neste momento. O seu cesto é guardado. Por favor, peça ajuda ao pessoal.',
  },
  cash_note: 'Pague em dinheiro ao balcão.',
  confirmation: {
    bring_to_table: 'Levamos o seu pedido à sua mesa.',
    your_table: 'A sua mesa',
    moved_table: 'Mudou de mesa? Indique ao pessoal o número do seu pedido <strong>{{number}}</strong>.',
  },
  served: 'Servido',
};
